
import { Component, Vue, Prop } from 'vue-property-decorator'
import Viewer from 'v-viewer/src/component.vue'
import { Images } from '../../vue-extend.d'

@Component({
  name: 'previewImg',
  components: { Viewer },
})
export default class extends Vue {
  @Prop({
    type: Object,
  })
  private options
  private images: Images[] = []
  private $viewer: any = null
  private inited(viewer) {
    this.$viewer = viewer
    this.$emit('inited', viewer)
    Vue.prototype.$privewImg = this.openFile
  }
  public openFile(images: Images[], index?: number) {
    this.images = []
    this.images = images
    this.$nextTick(() => {
      this.$viewer.update().view(index || 0)
    })
    this.$viewer.show()
  }
  private hidden() {
    this.images = []
    this.$emit('hidden')
  }
}
